var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLockIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 6.35417H13.6459V4.89583C13.6459 2.88333 12.0125 1.25 10 1.25C7.98752 1.25 6.35419 2.88333 6.35419 4.89583V6.35417H5.62502C4.82294 6.35417 4.16669 7.01042 4.16669 7.8125V15.1042C4.16669 15.9062 4.82294 16.5625 5.62502 16.5625H14.375C15.1771 16.5625 15.8334 15.9062 15.8334 15.1042V7.8125C15.8334 7.01042 15.1771 6.35417 14.375 6.35417ZM10 12.9167C9.19794 12.9167 8.54169 12.2604 8.54169 11.4583C8.54169 10.6562 9.19794 10 10 10C10.8021 10 11.4584 10.6562 11.4584 11.4583C11.4584 12.2604 10.8021 12.9167 10 12.9167ZM12.2604 6.35417H7.7396V4.89583C7.7396 3.64896 8.75315 2.63542 10 2.63542C11.2469 2.63542 12.2604 3.64896 12.2604 4.89583V6.35417Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLockIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lock-icon.0aadccaddfb0288d6d0c321e8a86c27d.svg";